<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="cip">
<p class="crtf"><a class="page" id="piv"></a><b>James Farrer</b> is professor of sociology and global studies at Sophia University, Tokyo, and author of <i>Opening Up: Youth Sex Culture and Market Reform in Shanghai</i>, also published by the University of Chicago Press. <b>Andrew David Field</b> is the author of <i>Shanghai’s Dancing World: Cabaret Culture and Urban Politics, 1919–1954</i> and <i>Mu Shiying: China’s Lost Modernist</i>.</p>
<p class="crtf">The University of Chicago Press, Chicago 60637</p>
<p class="crt">The University of Chicago Press, Ltd., London</p>
<p class="crt">© 2015 by The University of Chicago</p>
<p class="crt">All rights reserved. Published 2015.</p>
<p class="crt">Printed in the United States of America</p>
<p class="crtf">24 23 22 21 20 19 18 17 16 15    1 2 3 4 5</p>
<p class="crtf"><span class="sm">ISBN</span>-13: 978-0-226-26274-1 (cloth)</p>
<p class="crt"><span class="sm">ISBN</span>-13: 978-0-226-26288-8 (paper)</p>
<p class="crt"><span class="sm">ISBN</span>-13: 978-0-226-26291-8 (e-book)</p>
<p class="crt"><span class="sm">DOI</span>: 10.7208/chicago/9780226262918.001.0001</p>
<p class="cipf">Library of Congress Cataloging-in-Publication Data</p>
<p class="cipf">Farrer, James (James C.), author.</p>
<p class="cip1">Shanghai nightscapes : a nocturnal biography of a global city / James Farrer and Andrew David Field.</p>
<p class="cip2">pages cm</p>
<p class="cip1">Includes bibliographical references and index.</p>
<p class="cip1"><span class="sm">ISBN</span> 978-0-226-26274-1 (cloth : alkaline paper)—<span class="sm">ISBN</span> 978-0-226-26288-8 (paperback : alkaline paper)—<span class="sm">ISBN</span> 978-0-226-26291-8 (e-book) 1. Nightlife—China—Shanghai. 2. Shanghai (China)—Social life and customs—20th century. I. Field, Andrew David, author. II. Title.</p>
<p class="cip1"><span class="sm">DS</span>796.<span class="sm">S</span>25<span class="sm">F</span>37 2015</p>
<p class="cip1">951'.13205—dc23</p>
<p class="cipl">2014043024</p>
<p class="crtf">♾ This paper meets the requirements of <span class="sm">ANSI/NISO</span> <span class="sm">Z</span>39.48–1992 (Permanence of Paper).</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-farrer-0004.vue?1576de36